import { ActivatedRoute } from "@angular/router";
import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, Subscription } from "rxjs";

import { AuthService } from "../services/auth.service";
import { Store } from "@ngrx/store";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  apiUrl: string;
  appConfig: any;
  subscriptions: Subscription[] = [];
  constructor(
    private authenticationService: AuthService,
    private route: ActivatedRoute,
    private store: Store<{ config: any }>
  ) {
    this.subscriptions.push(
      store.select("config").subscribe((res) => {
        this.apiUrl = res.apiUrl;
        this.appConfig = res;
      })
    );
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add auth header with jwt if user is logged in and request is to api url
    const user = this.authenticationService.clientUserValue;
    const isLoggedIn = user && user?.data?.token;
    const isApiUrl = request.url.startsWith(this.apiUrl);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user?.data?.token}`,
          "ngrok-skip-browser-warning": "true",
        },
      });
    }

    return next.handle(request);
  }
}
